










































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { STATUS } from '@front-app/constants/state';
import { useStatus } from '@front-app/hooks/useAsyncStatus';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { Spacing } from '@front-app/components/constants';
import PlusButtonVue from '@front-app/components/buttons/PlusButton.vue';

let n = 0;
const getId = () => {
	n += 1;
	return `add-category-${n}`;
};

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		SuccessCard,
		ErrorCard,
	},
	props: {
		id: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			required: true,
		},
		buttonText: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			default: '',
		},
		status: {
			type: String as PropType<STATUS>,
			default: STATUS.UNSTARTED,
		},
		showCancelButton: Boolean,
		usePlusButton: Boolean,
	},
	setup(props) {
		const {
			isLoading,
			isError,
			isSuccess,
		} = useStatus(computed(() => props.status));
		const computedId = computed(() => {
			if (props.id) {
				return props.id;
			}
			return getId();
		});
		const submitButtonComponent = computed(() => (props.usePlusButton ? PlusButtonVue : CtaButton));
		return {
			submitButtonComponent,
			computedId,
			isLoading,
			isError,
			isSuccess,
			Spacing,
		};
	},
});
